import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Box, Icon } from "@mui/material";
import { styled } from '@mui/material';
import { useState } from "react";

const StyledHeader = styled(Box)(() => ({
  maxHeight: "1rem",

  ".header": {
    marginTop: "0rem",
  },

  ".up-icon": {
    position: "absolute",
    right: "2rem",
    top: "0rem",
    cursor: "pointer",
  },

  ".down-icon": {
    position: "absolute",
    right: "2rem",
    top: ".6rem",
    cursor: "pointer",
  },
}));

const sortingLookup = {
  ASC: "asc",
  DESC: "desc",
};

interface IHeaderCell {
  column: any;
}

const HeaderCell = ({ column }: IHeaderCell) => {


  const [sorting, setSorting] = useState<string | null>(null);

  const handleSorting = (type: string) => {
    if (sorting === type) {
      setSorting(null);
    } else {
      setSorting(type);
    }
  };

  return (
    <StyledHeader>
      <p className="header icon-svg">{column.columnDef.header}</p>
      <div>
        <Icon
          className="up-icon"
          fontSize="small"
          onClick={() => handleSorting(sortingLookup?.ASC)}
        >
          <ArrowDropUpIcon
            htmlColor={sorting === sortingLookup?.ASC ? "black" : "#A7A8A9"}
            fontSize="small"
          />
        </Icon>
        <Icon
          className="down-icon"
          fontSize="small"
          onClick={() => handleSorting(sortingLookup?.DESC)}
        >
          <ArrowDropDownIcon
            htmlColor={sorting === sortingLookup?.DESC ? "black" : "#A7A8A9"}
            fontSize="small"
          />
        </Icon>
      </div>
    </StyledHeader>
  );
};

export { HeaderCell };
export default HeaderCell;
